import type { SymbolPackDTO, SymbolUsageEnum } from '@nora-monorepo/nora-api-client';

import type { IdbStoreRecord } from '#ui-shared/idb-object-store/idb-object-store';
import { IdbObjectStore } from '#ui-shared/idb-object-store/idb-object-store';
import { symbolDatabase } from '#ui-shared/symbol-cache/symbol-database';

interface CachedSymbolPackListRecord extends IdbStoreRecord {
  packs: SymbolPackDTO[];
}

/**
 * IndexedDB-backed cache for symbol pack lists. Symbol pack lists are stored in IndexedDB, allowing for efficient storage and retrieval of pack metadata. This cache is used to store lists of symbol packs based on their usage, while individual pack metadata is stored separately in the SymbolPackIdbCache and the actual symbol images are stored in the SymbolIdbCache.
 */
class SymbolPackListIdbCache extends IdbObjectStore<CachedSymbolPackListRecord> {
  constructor() {
    super({
      database: symbolDatabase,
      storeName: 'symbolPackLists',
    });
  }

  async getList(usage: SymbolUsageEnum): Promise<SymbolPackDTO[] | undefined> {
    const record = await this.get(this.keyFor(usage));

    return record?.packs;
  }

  async setList(usage: SymbolUsageEnum, packs: SymbolPackDTO[]): Promise<void> {
    await this.put({ key: this.keyFor(usage), packs });
  }

  private keyFor(usage: SymbolUsageEnum): string {
    return `usage:${usage}`;
  }
}

export const symbolPackListIdbCache = new SymbolPackListIdbCache();
